import React from "react";

import Editor from './ABridSideInfoEditor'
import EditorWrapper from '../../EditorWrapper'

import BridSideInfo from "../../common/BridSideInfo";
import TimerArticle from "../../common/EmptyArticle";


const ABridSideInfo = props => {
    let article = TimerArticle();
    const { settings } = props;

    article.title = settings.title_normal;
    article.url = settings.link;
    article.label = settings.label;
    article.time = settings.time;
    article.titleTop = settings.title_top


    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridSideInfo article={article} disableVote={props.disableVote} />
        </div>
    );
};

export default ABridSideInfo;
